export interface MarketDistributionItem {
  id: string;
  y: number;
  color: string;
  symbol: string;
  market: string;
  name?: string;
  cumQty?: string;
  orderQty?: string;
  avgPxAllIn?: string;
  avgPx?: string;
  cumFee?: string;
  feeCurrency?: string;
  price?: string;
  leavesQty?: string;
  priceCurrency?: string;
  sizeCurrency?: string;
  sizeIncrement?: string;
  priceIncrement?: string;
}
export const REMAINDER = 'REMAINDER';

/** Which leg of a multileg order's Market Distribution charts are currently displayed. */
export const MarketDistributionLegEnum = {
  Order: 'order',
  Leg1: 'leg1',
  Leg2: 'leg2',
} as const;
export type MarketDistributionLegEnum = (typeof MarketDistributionLegEnum)[keyof typeof MarketDistributionLegEnum];
